export default "__VITE_ASSET__8eK6B4jR__"